import React, { useEffect, useState } from 'react';
import '../styles/navbar.css';

const Navbar = () => {
    const [weather, setWeather] = useState(null);

    useEffect(() => {
        const fetchWeather = async () => {
            try {
                const response = await fetch(
                    `https://api.openweathermap.org/data/2.5/weather?q=Toronto&appid=9bbeca482964dc1cb04b7165bee90e19&units=metric`
                );
                const data = await response.json();
                setWeather({
                    temp: Math.round(data.main.temp),
                    description: data.weather[0].main,
                    icon: `https://openweathermap.org/img/wn/${data.weather[0].icon}@2x.png`,
                });
            } catch (error) {
                console.error('Error fetching weather data:', error);
            }
        };

        fetchWeather();
    }, []);

    return (
        <nav className="navbar">
            <div className="container">
                {/* Navigation Links */}
                <ul className="nav-links">
                    <li><a href="#home" className="nav-link">Home</a></li>
                    <li><a href="#projects" className="nav-link">Projects</a></li>
                    <li><a href="#skills" className="nav-link">Skills</a></li>
                    <li><a href="#contact" className="nav-link">Contact</a></li>
                </ul>
                {/* Weather Section */}
                <div className="weather-info">
                    {weather ? (
                        <>
                            <img src={weather.icon} alt="weather icon" className="weather-icon" />
                            <div className="weather-details">
                                <span className="weather-temp">{weather.temp}°C</span>
                                <span className="weather-desc">{weather.description}</span>
                            </div>
                        </>
                    ) : (
                        <span>Loading weather...</span>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
